import { FieldBlock, InputBlock } from '@coast/schemas';
import { ReactElement } from 'react';
import { Switch } from '@shared/components/form/switch';
import { BlockIcon, ClearButton, InputError, InputLabel } from './formInputSubcomponents';

export function renderIcon(icon: FieldBlock['icon'], name?: string): ReactElement {
  // @ts-expect-error -- strict migration
  return !!icon && <BlockIcon name={name} icon={icon} />;
}

export function renderLabel(block: InputBlock): ReactElement {
  return <InputLabel block={block} />;
}

export function renderClearButton(block: InputBlock, onClear?: () => void): ReactElement {
  return <ClearButton block={block} onClear={onClear} />;
}

export function renderError(block: InputBlock): ReactElement {
  return <InputError block={block} />;
}

export function renderToggle(value: boolean, onChange: (value: boolean) => void) {
  return <Switch value={value} onValueChange={onChange} />;
}
